import { useEffect } from "react";
import { useAppState } from "../../../store/features/app/state";

const DarkModeHandler = () => {
	const { state } = useAppState();
	const darkMode = state.darkMode();

	useEffect(() => {
		document.documentElement.classList.toggle("dark", darkMode);
	}, [darkMode]);

	return null;
};

export default DarkModeHandler;
